.page {
  width: 100%;
  min-height: 100dvh;
  position: relative;
  flex-direction: column;
}

.pageWrap {
  display: flex;
  height: 100dvh;
  width: 100%;
  position: relative;
  // TNBEWEB-2019: NO `justify-content` here. This used to hardcode `center`,
  // which won whenever `settings.style.flex` was absent (every screen whose
  // Layout was never touched) — the canvas showed the root content left, the
  // published link showed it centered. The root alignment now comes from the
  // inline style Page builds out of `settings.style.flex`, resolved through
  // ROOT_FLEX_DEFAULTS, which is the same object the editor's canvas uses.
  overflow-y: auto;
  overflow-x: hidden;
}

// TNBEWEB-2019 (V2): with a column root, height is the flex MAIN axis, so a root
// section declaring `height: 1200px` inside this 100dvh box was silently shrunk
// to the window height (default `flex-shrink: 1`) and its content cut off —
// `overflow-y: auto` never engaged because nothing overflowed. Pinning the root
// children turns the excess back into scrolling, which is what the canvas shows.
// Row direction is deliberately left alone: there height is the CROSS axis and
// is already preserved, while pinning would stop wide sections from fitting and
// `overflow-x: hidden` would clip them out of reach.
.pageWrapColumn > * {
  flex-shrink: 0;
}
